import { BackArrowIcon, CancelIcon } from "cssReset/icon";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

interface HeaderProps {
  onClick?: () => void;
  headerTitle: string;
  step: number;
  initStep: () => void;
}

const InspectHeader = ({
  headerTitle,
  onClick,
  step,
  initStep,
}: HeaderProps) => {
  const navigate = useNavigate();

  const closedClickedHandler = () => {
    initStep();
  };

  return (
    <HeaderContainer>
      <div className="icon-box" onClick={onClick}>
        <BackArrowIcon />
      </div>
      <div className="header-title">
        <p>{headerTitle}</p>
      </div>
      {step !== 0 && (
        <div className="icon-box">
          <button onClick={closedClickedHandler}>
            <CancelIcon />{" "}
          </button>
        </div>
      )}
    </HeaderContainer>
  );
};

export default InspectHeader;

const HeaderContainer = styled.header`
  height: 5.6rem;
  display: grid;
  grid-template-columns: 4.8rem auto 4.8rem;
  align-items: center;
  position: sticky;
  top: 0;
  left: 0;
  background-color: white;
  width: 100%;
  z-index: 99;
  .icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
  .header-title {
    display: flex;
    align-items: center;
    p {
      font-size: 1.6rem;
      font-weight: 500;
      letter-spacing: -0.06rem;
      line-height: 2rem;
      transform: translateY(1px);
    }
  }
  .icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    button {
      display: flex;
      background-color: transparent;
      border: none;
      outline: none;
      width: 2.4rem;
      height: 2.4rem;
      padding: 0;
      margin: 0;
      svg {
        width: 100%;
        height: 100%;
      }
    }
  }
`;
